var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq21(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.175,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4113,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.9988,
    y1: 12.1824,
    x2: 50.2351,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.32498,
    y1: 49.8543,
    x2: 12.5613,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.761,
    y1: 38.6199,
    x2: 49.9973,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.08713,
    y1: 0.944118,
    x2: 12.3234,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.714 29.23C22.4313 27.942 23.7567 26.7893 24.69 25.772C25.6327 24.7453 26.104 23.742 26.104 22.762C26.104 22.118 25.9407 21.6047 25.614 21.222C25.2967 20.83 24.774 20.634 24.046 20.634C23.3367 20.634 22.786 20.858 22.394 21.306C22.0113 21.7447 21.7967 22.3327 21.75 23.07H20.798C20.854 22.034 21.1713 21.2313 21.75 20.662C22.338 20.0833 23.1033 19.794 24.046 19.794C24.9513 19.794 25.684 20.0507 26.244 20.564C26.804 21.068 27.084 21.7867 27.084 22.72C27.084 23.8493 26.6127 24.946 25.67 26.01C24.7367 27.0647 23.584 28.096 22.212 29.104H27.392V29.93H20.714V29.23ZM28.4457 20.844V19.962H30.8257V30H29.8317V20.844H28.4457Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq21);
export default __webpack_public_path__ + "static/media/fq21.90131dc9da5fd805480e7e7469ba19b4.svg";
export { ForwardRef as ReactComponent };